/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { HttpFile } from '../http/http';

/**
* The event emitted when an Order Line is deployed with a config.
*/
export class V1OrderLineDeployedWithConfig {
    'id'?: string;
    /**
    * The org ID of the Order Line that is being deployed.
    */
    'orgId'?: string;
    /**
    * The IDs of the creatives associated to the Order Line that are to be deployed.
    */
    'creativeIds'?: Array<string>;
    /**
    * The IDs of the target jobs associated to the Order Line that are to be deployed.
    */
    'targetJobIds'?: Array<string>;
    'deploymentDestination'?: Deployservicev3Destination;
    /**
    * The org ID of the Order Line that is being deployed.
    */
    'timestamp'?: Date;
    'userId'?: string;
    'requestId'?: string;
    'config'?: string;
    'stepFunction'?: string;
    'status'?: V1OrderLineStatus;
    'scheduledTime'?: Date;
    'campaignId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "creativeIds",
            "baseName": "creative_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetJobIds",
            "baseName": "target_job_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "deploymentDestination",
            "baseName": "deployment_destination",
            "type": "Deployservicev3Destination",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "config",
            "baseName": "config",
            "type": "string",
            "format": "byte"
        },
        {
            "name": "stepFunction",
            "baseName": "step_function",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1OrderLineStatus",
            "format": ""
        },
        {
            "name": "scheduledTime",
            "baseName": "scheduled_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineDeployedWithConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

